import { CupOutlineIcon } from './CupOutlineIcon';

/**
 * author: Simran
 * id FEA3388A-F985-482C-8CE0-0B4ABCD31691
 * name cup-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cup-outline.svg
 * tags
 * - Food / Drink 
 */
export const CupEmptyIcon = CupOutlineIcon;
export default CupEmptyIcon